export const queryOperators = {
  AND: 'AND',
};

export const locationConditions = {
  EQUALS: 'EQUALS',
  IS_NOT_EQUAL_TO: 'IS_NOT_EQUAL_TO',
  IS_WITHIN_RADIUS: 'IS_WITHIN_RADIUS',
};
